class MobileNavToggles {
  constructor(element, options) {
    this.element = element;
    this.options = options;

    this.toggleBtn = element.querySelector(this.options.selectorToggle);

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => {
        this._toggle();
      });
    }
  }

  static create(element) {
    new this(element, this.options);
  }

  static init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mobile-nav-group]'), element => {
      this.create(element);
    });
  }

  _toggle() {
    const expanded = this.toggleBtn.getAttribute('aria-expanded');

    if (expanded !== null) {
      this.toggleBtn.setAttribute('aria-expanded', expanded === 'true' ? 'false' : 'true');
    }

    this.element.classList.toggle(this.options.classActive);
  }

  static options = {
    selectorToggle: '[data-mobile-nav-toggle]',
    classActive: 'is-active',
  };
}

export default MobileNavToggles;
